import { Module, State } from "../decorators";

import OrderStore from 'app/stores/order';
import DispatchStore from 'app/stores/dispatch';

// Controllers
import {ApplicatorCtrl, HaulerCtrl} from './ctrls';

// Templates
import dispatchTpl from './templates/dispatch.html';
import applicatorTpl from './templates/applicator.html';
import haulerTpl from './templates/hauler.html';


@Module({
    name: 'app.dispatch',
    modules: [
        OrderStore,
        DispatchStore,
    ],
})
@State({
    name: 'r.in.top.dispatch',
    url: '/dispatch',
    template: dispatchTpl,
    abstract: '.applicator',
    data : {
        permissions: {
            only: [
                'main.can_dispatch_order',
            ]
        },
    },
    ncyBreadcrumb: {
        label: 'Dispatch',
    },
})
@State({
    name: 'r.in.top.dispatch.applicator',
    url: '/applicator',
    controller: ApplicatorCtrl,
    template: applicatorTpl,
    ncyBreadcrumb: {
        skip: true,
    },
})
@State({
    name: 'r.in.top.dispatch.hauler',
    url: '/hauler',
    controller: HaulerCtrl,
    template: haulerTpl,
    ncyBreadcrumb: {
        skip: true,
    },
})
@State({
    name: 'r.in.top.dispatch.mixer',
    url: '/mixer',
    template: '<order-priority-list></order-priority-list>',
    ncyBreadcrumb: {
        skip: true,
    },
})

export default class States { }



// WEBPACK FOOTER //
// ./src/app/dispatch/routing.js